import { Language } from '@schenck/rotec-components';

export const AVAILABLE_LANGS: Language[] = ['en', 'de'];

export const DEFAULT_LANG: Language = 'en';
